import { useAuth } from "../contexts/AuthContext";
import { Domain } from "../types"

const AddDomainBanner = ({ domains }: {
  domains: Domain[]
}) => {
  const { user } = useAuth();

  // if email is not yet verified, then no need to show this banner
  // since email shall be verified first before domain can be added
  if (user && !user.email_verified) return null;

  // no need to show the banner if there is valid domain
  if (domains.some(d => !!d.domain)) return null;

  return (
    <div className="yellow-banner">
      Please add a domain before creating your keyword clusters!
    </div>
  )
}

export default AddDomainBanner